// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-55ab0216]::-webkit-scrollbar{width:12px}[data-v-55ab0216]::-webkit-scrollbar-thumb,[data-v-55ab0216]::-webkit-scrollbar-track{--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
